<template>
    <div style="height:100%">
        <Button class="apply-btn" v-if="!originalCtrl && !sumbitCtrl" :disabled="formOriginal.length==0" type="primary" @click="sendOriginalInfo()">确定</Button>
        <Row>
            <checkbox-table :columns="changeTableColumns()" :data="alreadyOriginal.length==0?originalInfo:alreadyOriginal" rowKey="indexId" ref="checkboxTable"
                @refreshList="getIdList($event)">
                <template slot-scope="{ row, index }" slot="more-actions" v-if="alreadyOriginal.length>0">
                        <Dropdown transfer @on-click="option(row,$event)">
                                <a href="javascript:void(0)">
                                    <Icon type="ios-more" size="20"/>
                                </a>
                                <DropdownMenu slot="list">
                                    <DropdownItem name="mailInfo">邮寄信息</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                    </template>
            </checkbox-table>
        </Row>
        <!-- 邮寄信息 -->
        <Modal
            v-model="mailInfoCtrl"
            title="邮寄信息"
            :width="600"
            :footer-hide="true">
            <Form ref="mailinfoValidate" :model="mailinfo" :label-width="100">
                <FormItem class="mgb" label="文件名称">
                    {{mailinfo.name}}
                </FormItem>
                <FormItem class="mgb" label="邮寄方式">
                    {{mailinfo.typeName}}
                </FormItem>
                <FormItem class="mgb" label="寄件人">
                    {{mailinfo.sender}}
                </FormItem>
                <FormItem class="mgb" label="寄件人电话">
                    {{mailinfo.senderPhone}}
                </FormItem>
                <FormItem class="mgb" label="收件人">
                    {{mailinfo.recipient}}
                </FormItem>
                <FormItem class="mgb" label="收件人电话">
                    {{mailinfo.recipientPhone}}
                </FormItem>
                <FormItem class="mgb" label="快递公司">
                    {{mailinfo.courierCompany}}
                </FormItem>
                <FormItem class="mgb" label="快递单号">
                    {{mailinfo.courierNumber}}
                </FormItem>
                <FormItem class="mgb" label="邮寄时间">
                    {{mailinfo.deliveryTime}}
                </FormItem>
            </Form>
            <logistics-information v-if="logisticsCtrl" :expressNo="mailinfo.courierNumber" :company="mailinfo.courierCompany"></logistics-information>
        </Modal>
        <!-- 文件浏览 -->
        <preview-file ref="perviewFile"></preview-file>
    </div>
</template>

<script>
import fileImage from '@/components/common/fileImage/fileImage.vue';
import styles from '@/assets/globalStyle.scss';
export default {
    data(){
        return {
            originalCtrl:false, //未提交原件申请
            mailInfoCtrl:false,
            logisticsCtrl:false,
            sumbitCtrl:false,// 确认按钮
            mailinfo:{},
            formOriginal:[], // 原件申请提交数据
            originalInfo:[], // 未提交时原件信息
            alreadyOriginal:[],// 已提交时原件信息
            columns:[

            ]
        }
    },
    props: ['processId','caseId','projectId'],
    methods: {
        option(row,data){
            let url = `/business/originalApplicationMailing/original-application-mailing/${row.id}`
            this.$get(url).then(res=>{
                if(res.code==0 && res.data){
                    this.mailInfoCtrl = true
                    this.mailinfo = res.data
                    this.logisticsCtrl=true
                }else{
                    this.$Message.error('暂无数据')
                }
            })
        },
        // 获取未提交原件信息
        getOriginalInfo(){
            let url = '/business/material/'+this.projectId+'/original';
            this.$get(url).then(res=>{
                if(res.code=='0'){
                    this.originalInfo = res.data
                }
            })
        },
        // 获取已提交原件信息
        getAlreadyOriginalData(){
            let url = '/business/original-application/' + this.processId;
            this.$get(url).then(res=>{
                if(res.code=='0'){
                    this.alreadyOriginal = res.data.originalApplicationList
                    if(this.alreadyOriginal.length >0){
                        this.originalCtrl = true;
                    }
                    this.changeTableColumns();
                }
            })
        },
        // 提交原件申请
        sendOriginalInfo(){
            let url = '/business/original-application';
            let ajaxData = {
                originalApplicationList: this.formOriginal
            }
            this.$post(url, ajaxData).then(res=>{
                if(res.code == 0){
                    this.getAlreadyOriginalData()
                }
            })
        },
        // 列表类
        changeTableColumns(){
            let columns = [];
            let columnsList = [
                {
                    title:"类型",
                    width: '50',
                    render:(h,params)=>{
                        return h(fileImage,{
                            attrs:{
                                title:params.row.name,
                                mediaType:params.row.attachment?params.row.attachment.mediaType:'',
                                fileName:params.row.attachment?params.row.attachment.fileName:'',
                                size:"28"
                            }
                        })
                    }
                },
                {
                    title:"文件名",
                    key:"name",
                    render:(h,params)=>{
                        return h('span',{
                            class:'textover',
                            attrs:{
                                title:params.row.name
                            },
                            style:{
                                cursor: 'pointer',
                                color: styles.globalMainColor
                            },
                            on:{
                                click:()=>{
                                    this.$refs.perviewFile.preview(params.row.attachment);
                                }
                            }
                        },params.row.name)
                    }
                }
            ];
            let alreadyArr = [
                {
                    title:"寄件人",
                    key:"sender",
                    render:(h,params)=>{
                        return h('span',{
                            class:'textover',
                            attrs:{
                                title:params.row.sender
                            },
                        },params.row.sender||'-')
                    }
                },
                {
                    title:'寄件时间',
                    key:'deliveryTime',
                    render:(h,params)=>{
                        let mailTimeStr = params.row.deliveryTime?this.common.formatTime(new Date(params.row.deliveryTime)):'-';
                        return h('span',{
                            class:'textover',
                            attrs:{
                                title:mailTimeStr
                            },
                        },mailTimeStr)
                    }
                },
                {
                    title:"邮寄状态",
                    key:"typeName",
                    render:(h,params)=>{
                        let color = "";
                        color = params.row.typeName?'successColor':'errorColor';
                        let state = params.row.typeName?'已邮寄':'未邮寄'
                        return h('Tag',{
                            // style:{
                            //     color:style.globalMainColor,
                            //     cursor: 'pointer'
                            // },
                            class:'textover',
                            attrs:{
                                title:state,
                                color:styles[color]
                            },
                            
                        },state)
                    }
                },
                {
                    title:'操作',
                    slot:'action'
                }
            ]
            
            if(this.alreadyOriginal.length == 0){
                columns.push({ type: 'selection',width: 30,align: 'center',});
                columns = columns.concat(columnsList)
            } else {
                columns = columnsList.concat(alreadyArr);
            }
            return columns
        },
        // 原件勾选数据
        getIdList(data){
            this.formOriginal = []
            this.formOriginal = data.map(item=>{
                return {
                    caseId: this.caseId,
                    materialAttachId: item.materialId,
                    name: item.name,
                    processId: this.processId,
                    projectId: this.projectId
                }
            })
        }
    },
    created(){
        // 当完成调解，和解，判决时不可申请原件
        this.$attrs.processList && this.$attrs.processList.forEach(item => {
            // 调解:ME_AP;和解:RE_AP;判决:JT_BB
            if ((item.code === 'ME_AP' || item.code == 'RE_AP' || item.code === 'JT_BB') && item.state == 2) {
                this.sumbitCtrl = true
            }
        })
    },
    beforeMount(){},
    mounted(){
        this.getOriginalInfo();
        this.getAlreadyOriginalData();
    },
    updated(){},
    components: {
        fileImage
    },
    watch: {}
}
</script>

<style lang="scss" scoped>
.apply-btn{
    float: right;
    margin-top:-54px;
}
.mgb {
    margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/view/civilCase/pretrial/originalApply.vue